import { AUTH_USER_ERROR } from "store/actions/auth/";
import { api } from "utils/api";
import { closeModal, showMessage } from "store/actions/notifications/";
import i18n from "i18n";
import { getRouteParams } from "utils/url";
import { fileUploadTypes } from "utils/constants";

export const MESSAGES_UPLOAD_LINK_REQUEST = "MESSAGES_UPLOAD_LINK_REQUEST";
export const MESSAGES_UPLOAD_LINK_SUCCESS = "MESSAGES_UPLOAD_LINK_SUCCESS";
export const MESSAGES_UPLOAD_LINK_ERROR = "MESSAGES_UPLOAD_LINK_ERROR";

export function getMessageUploadLink(file) {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGES_UPLOAD_LINK_REQUEST,
      });
      const { customerId } = getRouteParams();
      const result = await api.post(
        `/customers/${customerId}/files/presigned-url`,
        {
          mime: file.mime,
          filename: file.filename,
          size: file.size,
          type: fileUploadTypes.MESSAGE,
        },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        },
      );
      const { status } = result;
      if (status === 200) {
        const { data } = result;
        dispatch({
          type: MESSAGES_UPLOAD_LINK_SUCCESS,
        });
        return data;
      }
      throw new Error(result.statusText);
    } catch (error) {
      const { response } = error;
      const { data } = response;
      console.error(data);
      if (data.status === 401) {
        dispatch({
          type: AUTH_USER_ERROR,
        });
      } else {
        dispatch({
          type: MESSAGES_UPLOAD_LINK_ERROR,
        });
        dispatch(
          showMessage({
            title: i18n.t("global.error"),
            text: i18n.t("errors.errorGetUploadlink"),
            type: "error",
          }),
        );
        dispatch(closeModal());
      }
    }
    return "";
  };
}
